export default __webpack_public_path__ + "assets/models/be02eb7eba965eede410714e44c21ab2.glb";